/* global BackboneEx */
import { enableRecording } from 'common/analytics';

// THY-2129: record Menu sessions only for venues that signed up
// for Connect within this rolling window, measured back from page load
const MENU_RECORDING_VENUE_SIGNUP_WINDOW_DAYS = 14;

App.Views.Menu = BackboneEx.View.Main.extend({
  tabsInitialized: false,

  initialize: function initialize() {
    enableRecording();
    this.lastVenueId = App.getVenueId();
    this.maybeStartMenuSessionRecording();
  },

  maybeStartMenuSessionRecording: function maybeStartMenuSessionRecording() {
    // This view also serves the Products page; the study covers /menu only
    const isMenuPage = window.location.href.includes('/menu');
    if (
      isMenuPage &&
      Wahanda.Features.isEnabled('THY-record-menu-filling-session') &&
      Wahanda.SessionReplay.isVenueSignedUpWithinLastDays(MENU_RECORDING_VENUE_SIGNUP_WINDOW_DAYS)
    ) {
      Wahanda.SessionReplay.startRecording();
    }
  },

  showLoader: function showLoader() {
    this.lastShownLoader = this.$('.data-content:visible').loadmask();
  },

  hideLoader: function hideLoader() {
    return this.lastShownLoader && this.lastShownLoader.unloadmask();
  },

  getSelectedTab: function getSelectedTab() {
    const index = this.$el.tabs('option', 'selected');
    // Return the string #hash
    return this.$('.ui-tabs-nav').find('a').eq(index);
  },

  selectTab: function selectTab(hash) {
    const tabIndex = this.$('.ui-tabs-nav')
      .children()
      .index(this.$(`${hash}-tab`));
    this.$el.tabs('option', 'selected', tabIndex);
  },

  render: function render() {
    const page = window.location.href.includes('/menu') ? 'menu' : 'products';
    App.headerView.setModule(page);

    const menuNode = document.getElementById('menu-holder');

    if (App.getVenueId() !== this.lastVenueId) {
      // Destroy the previous state, as we have a new venue
      App.ES6.Initializers.Menu.destroy(menuNode);
      this.lastVenueId = App.getVenueId();
    }

    App.ES6.Initializers.Menu.render(menuNode, App.config.toJSON(), {
      tab: (App.mainViewOptions || {}).initialTab,
      page,
    });
    this.$('#nav2 .title:visible').center({ horizontal: false });
  },
});
